import { Injectable } from '@angular/core';
import { ApiService } from '../../../../_core/_services/api.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortalManagementBillingService {
  constructor(private api: ApiService) {}

  createManualBilling(subscriptionReference: string, data: any): Observable<any> {
    return this.api
      .postAPI(
        `portal/management/subscription/${subscriptionReference}/manual-billing?generate_transaction=true`,
        data
      )
      .pipe(
        map((res: any) => {
          return res.body;
        })
      );
  }
}
